export const themeToggler = function () {
    const themeToggleDarkIcon = document.getElementById("theme-dark");
    const themeToggleLightIcon = document.getElementById("theme-light");

    // Change the icons inside the button based on previous settings
    if (
        localStorage.getItem("color-theme") === "dark" ||
        (!("color-theme" in localStorage) &&
            window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
        themeToggleLightIcon.classList.remove("hidden");
    } else {
        themeToggleDarkIcon.classList.remove("hidden");
    }

    var themeToggleBtn = document.getElementById("toggle-theme");

    themeToggleBtn.addEventListener("click", function () {
        // toggle icons inside button
        themeToggleDarkIcon.classList.toggle("hidden");
        themeToggleLightIcon.classList.toggle("hidden");

        // if set via local storage previously
        if (localStorage.getItem("color-theme")) {
            if (localStorage.getItem("color-theme") === "light") {
                document.documentElement.classList.add("dark");
                localStorage.setItem("color-theme", "dark");
            } else {
                document.documentElement.classList.remove("dark");
                localStorage.setItem("color-theme", "light");
            }

            // if NOT set via local storage previously
        } else {
            if (document.documentElement.classList.contains("dark")) {
                document.documentElement.classList.remove("dark");
                localStorage.setItem("color-theme", "light");
            } else {
                document.documentElement.classList.add("dark");
                localStorage.setItem("color-theme", "dark");
            }
        }
    });
    // const toggleButton = document.querySelector("#toggleTheme");
    // const icon = document.querySelector("#themeIcon use");
    // const expirationDate = new Date();
    // const domainName = window.location.hostname;
    // expirationDate.setDate(expirationDate.getDate() + 365);
    // // Chekcs if cookie exists (takes currentTheme)
    // let currentTheme =
    //     document.cookie.replace(
    //         /(?:(?:^|.*;\s*)preferred_theme\s*\=\s*([^;]*).*$)|^.*$/,
    //         "$1"
    //     ) || null;
    // // if 1st visit (no cookie)
    // if (!currentTheme) {
    //     const systemPrefersDark = window.matchMedia(
    //         "(prefers-color-scheme: dark)"
    //     ).matches;
    //     currentTheme = systemPrefersDark ? "dark" : "light";
    //     document.cookie = `preferred_theme=${currentTheme}; expires=${expirationDate.toUTCString()}; domain=${domainName}`;
    //     if (systemPrefersDark) {
    //         document.body.classList.add("dark-theme"); // Depreceated
    //         document.documentElement.classList.add("dark");
    //     }
    // }
    // if (
    //     currentTheme === "dark" &&
    //     !document.body.classList.contains("dark-theme")
    // ) {
    //     document.body.classList.add("dark-theme");
    //     document.documentElement.classList.add("dark");
    //     if (icon) {
    //         icon.setAttribute(
    //             "xlink:href",
    //             `/assets/img/sprite.svg#svg-icon-${
    //                 currentTheme === "dark" ? "light" : "dark"
    //             }`
    //         );
    //     }
    // }
    // if (toggleButton) {
    //     toggleButton.addEventListener("click", () => {
    //         const currentTheme =
    //             document.cookie.replace(
    //                 /(?:(?:^|.*;\s*)preferred_theme\s*\=\s*([^;]*).*$)|^.*$/,
    //                 "$1"
    //             ) || "light";
    //         document.body.classList.toggle(
    //             "dark-theme",
    //             currentTheme === "light"
    //         );
    //         document.documentElement.classList.toggle(
    //             "dark",
    //             currentTheme === "light"
    //         );
    //         if (icon) {
    //             //
    //             icon.setAttribute(
    //                 "xlink:href",
    //                 `/assets/img/sprite.svg#svg-icon-${
    //                     currentTheme === "light" ? "light" : "dark"
    //                 }`
    //             );
    //         }
    //         document.cookie = `preferred_theme=${
    //             currentTheme === "dark" ? "light" : "dark"
    //         }; expires=${expirationDate.toUTCString()}; domain=${domainName}`;
    //         // console.log(currentTheme);
    //     });
    // }
};
